import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.0769 4.07692C22.0769 2.92596 21.151 2 20 2C18.849 2 17.9231 2.92596 17.9231 4.07692V17.9231H4.07692C2.92596 17.9231 2 18.849 2 20C2 21.151 2.92596 22.0769 4.07692 22.0769H17.9231V35.9231C17.9231 37.074 18.849 38 20 38C21.151 38 22.0769 37.074 22.0769 35.9231V22.0769H35.9231C37.074 22.0769 38 21.151 38 20C38 18.849 37.074 17.9231 35.9231 17.9231H22.0769V4.07692Z" })
});
export default SvgAdd;
